import React, { Fragment, useState } from 'react'
import { Redirect } from 'react-router-dom'
import Modal from '../../components/Modal'
import Header from '../Header'
import Summary from './Summary'
import Gutter from './Gutter'
import AccountForm from './AccountForm'
import DeliveryDetails from './DeliveryDetails'
import PaymentDetails from './PaymentDetails'
import ArrowBack from '../../assets/img/arrow-back.png'

import './Checkout.css'

const Checkout = props => {
  const { orderIsEmpty, history } = props

  if (orderIsEmpty) {
    return <Redirect to="/" />
  }
  const goBack = () => history.push('/')

  const [showSummaryModal, setShowSummaryModal] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)

  const completeStep = step => () => {
    setCurrentStep(step + 1)
  }

  const toggleSummaryModal = () => {
    setShowSummaryModal(!showSummaryModal)
  }

  return (
    <Fragment>
      <Modal
        title="Order Summary"
        size="xl"
        isOpen={showSummaryModal}
        onRequestClose={toggleSummaryModal}>
        <Summary />
      </Modal>

      <Header onGoBack={goBack} />
      <div className="cookunity__checkout_container">
        <span className="back_button" onClick={goBack}>
          <img src={ArrowBack} alt="back" />
          Back to A la Carte
        </span>

        <div className="cookunity__checkout">
          <div className="steps_container">
            <AccountForm
              completeStep={completeStep(1)}
              isCompleted={currentStep > 1}
              isActive={currentStep === 1}
            />

            <DeliveryDetails
              onEdit={() => setCurrentStep(2)}
              completeStep={completeStep(2)}
              isCompleted={currentStep > 2}
              isActive={currentStep === 2}
            />

            <PaymentDetails isActive={currentStep === 3} />
          </div>

          <div className="summary_container">
            <h1 className="title">Order Summary</h1>
            <Summary />
          </div>

          <div className="gutter_container">
            <Gutter toggleSummaryModal={toggleSummaryModal} />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Checkout



// WEBPACK FOOTER //
// ./src/modules/Checkout/Checkout.jsx